export default __webpack_public_path__ + "static/media/playStore.2a0e0c4a.svg";